interface BadgeProps {
  label: string;
}

/**
 * @component Badge
 * @description Italicized text badge used for informational tags (e.g. "Members Only").
 * @param label - Text content displayed inside the badge.
 * @returns A `<p>` element with italicized styling.
 */
export default function Badge({ label }: BadgeProps) {
  return (
    <p className="text-secondary-base text-stone italic mt-2">
      {label}
    </p>
  );
}
